export default {
  pulldown: '\ue588',
  refreshempty: '\ue461',
  back: '\ue471',
  forward: '\ue470',
  more: '\ue507',
  'more-filled': '\ue537',
  scan: '\ue612',
  qq: '\ue264',
  weibo: '\ue260',
  weixin: '\ue261',
  pengyouquan: '\ue262',
  loop: '\ue565',
  refresh: '\ue407',
  'refresh-filled': '\ue437',
  arrowthindown: '\ue585',
  arrowthinleft: '\ue586',
  arrowthinright: '\ue587',
  arrowthinup: '\ue584',
  'undo-filled': '\ue7d6',
  undo: '\ue406',
  redo: '\ue405',
  'redo-filled': '\ue7d9',
  bars: '\ue563',
  chatboxes: '\ue203',
  camera: '\ue301',
  'chatboxes-filled': '\ue233',
  'camera-filled': '\ue7ef',
  'cart-filled': '\ue7f4',
  cart: '\ue7f5',
  'checkbox-filled': '\ue442',
  checkbox: '\ue7fa',
  arrowleft: '\ue582',
  arrowdown: '\ue581',
  arrowright: '\ue583',
  'smallcircle-filled': '\ue801',
  arrowup: '\ue580',
  circle: '\ue411',
  'eye-filled': '\ue568',
  'eye-slash-filled': '\ue822',
  'eye-slash': '\ue823',
  eye: '\ue824',
  'flag-filled': '\ue825',
  flag: '\ue508',
  'gear-filled': '\ue532',
  reload: '\ue462',
  gear: '\ue502',
  'hand-thumbsdown-filled': '\ue83b',
  'hand-thumbsdown': '\ue83c',
  'hand-thumbsup-filled': '\ue83d',
  'heart-filled': '\ue83e',
  'hand-thumbsup': '\ue83f',
  heart: '\ue840',
  home: '\ue500',
  info: '\ue504',
  'home-filled': '\ue530',
  'info-filled': '\ue534',
  'circle-filled': '\ue441',
  'chat-filled': '\ue847',
  chat: '\ue263',
  'mail-open-filled': '\ue84d',
  'email-filled': '\ue231',
  'mail-open': '\ue84e',
  email: '\ue201',
  checkmarkempty: '\ue472',
  list: '\ue562',
  'locked-filled': '\ue856',
  locked: '\ue506',
  'map-filled': '\ue85c',
  'map-pin': '\ue85e',
  'map-pin-ellipse': '\ue864',
  map: '\ue364',
  'minus-filled': '\ue440',
  'mic-filled': '\ue332',
  minus: '\ue410',
  micoff: '\ue360',
  mic: '\ue302',
  clear: '\ue434',
  smallcircle: '\ue868',
  close: '\ue404',
  closeempty: '\ue460',
  paperclip: '\ue567',
  paperplane: '\ue503',
  'paperplane-filled': '\ue86e',
  'person-filled': '\ue131',
  'contact-filled': '\ue130',
  person: '\ue101',
  contact: '\ue100',
  'images-filled': '\ue87a',
  phone: '\ue200',
  images: '\ue87b',
  image: '\ue363',
  'image-filled': '\ue877',
  'location-filled': '\ue333',
  location: '\ue303',
  'plus-filled': '\ue439',
  plus: '\ue409',
  plusempty: '\ue468',
  'help-filled': '\ue535',
  help: '\ue505',
  'navigate-filled': '\ue884',
  navigate: '\ue501',
  'mic-slash-filled': '\ue892',
  search: '\ue466',
  settings: '\ue560',
  sound: '\ue590',
  'sound-filled': '\ue8a1',
  'spinner-cycle': '\ue465',
  'download-filled': '\ue8a4',
  'personadd-filled': '\ue132',
  'videocam-filled': '\ue8af',
  personadd: '\ue102',
  upload: '\ue402',
  'upload-filled': '\ue8b1',
  starhalf: '\ue463',
  'star-filled': '\ue438',
  star: '\ue408',
  trash: '\ue401',
  'phone-filled': '\ue230',
  compose: '\ue400',
  videocam: '\ue300',
  'trash-filled': '\ue8dc',
  download: '\ue403',
  'chatbubble-filled': '\ue232',
  chatbubble: '\ue202',
  'cloud-download': '\ue8e4',
  'cloud-upload-filled': '\ue8e5',
  'cloud-upload': '\ue8e6',
  'cloud-download-filled': '\ue8e9',
  headphones: '\ue8bf',
  shop: '\ue609'
}
